import { createContext, useContext, useState, useCallback, useMemo } from 'react'

export const isLocalHost = () => {
  const h = window.location.hostname
  return h === 'localhost' || h.endsWith('.localhost')
}

const FeedbackModeContext = createContext({
  isFeedbackMode: false,
  toggleFeedbackMode: () => {},
  feedbackTransport: 'connected',
  setFeedbackTransport: () => {},
  isLocalMode: false,
})

export function FeedbackModeProvider({ children }) {
  const [isFeedbackMode, setIsFeedbackMode] = useState(false)
  const toggleFeedbackMode = useCallback(() => setIsFeedbackMode(v => !v), [])
  const [feedbackTransport, setFeedbackTransport] = useState(() => isLocalHost() ? 'local' : 'connected')

  const isLocalMode = feedbackTransport === 'local'

  const value = useMemo(() => ({
    isFeedbackMode,
    toggleFeedbackMode,
    feedbackTransport,
    setFeedbackTransport,
    isLocalMode,
  }), [isFeedbackMode, toggleFeedbackMode, feedbackTransport, isLocalMode])

  return (
    <FeedbackModeContext.Provider value={value}>
      {children}
    </FeedbackModeContext.Provider>
  )
}

export function useFeedbackMode() {
  return useContext(FeedbackModeContext)
}
